export const DEFAULT_SORT = 'id_desc';
export const DEFAULT_SEARCH_TYPE = 'apartments';
